/// <summary>
/// This class is a simple helper to handle events
/// </summary>
export default class Events
{
  /// <summary>
  /// Determines if a user clicked a link with the intention to open it in a new tab.
  /// Our users have specificed shift-clicking, ctrl-clicking, middle-mouse clicking and
  /// mouse-forward-button clicking to use for opening in a new tab.
  /// </summary>
  /// <param name="e">The browser event</param>
  /// <return>True or false</returns>
  static ClickedToOpenInNewTab(e)
  {
    // e.which == 2 is middle click
    // e.button == 4 is forward mouse button
    return !e || (e && (e.which === 2 || e.button === 4) || e.ctrlKey || e.shiftKey);
  }
}
